<template>
    <b-card header-tag="header" footer-tag="footer" class="mt-8">
        <template v-slot:header>
            <p class="mb-0" style="font-size: 21px">Listado de Precios Personalizados</p>
        </template>
        <b-row>              
            <b-col cols="6" md="6">
                <div >
                    <b-button v-b-tooltip.hover title="Carga Masiva" variant="info" @click="$emit('open-massive-import-modal')" >
                        <b-icon icon="upload" >
                    </b-icon></b-button>
                </div>
            </b-col>              
            <b-col cols="6" md="6">
                <div class="text-right">
                    <b-button variant="info" class="mr-2 text-white" :href="urlWebBackend+'download-precio-personalizados-csv/'+user.empresa_id" target="_blank">
                        Exportar Xls <b-icon icon="download"></b-icon>
                    </b-button>
                    <b-button variant="info" @click="$emit('open-search-item-modal')">Nuevo Item</b-button>
                </div>
            </b-col>
        </b-row>
        <b-card-text>
            <b-table 
                responsive
                :fields="fields" 
                striped hover 
                :items="items">
                <template v-slot:cell(codigo)="data">
                    {{ data.item.codigo }}
                </template>
                <template v-slot:cell(imagen)="data">
                    <div>{{data.item.nombre}}</div>
                    <div>
                        <b-img :src="data.item.imagen" width="100" height="100" fluid alt="Fluid image"></b-img>
                    </div>
                </template>
                <template v-slot:cell(precio)="data">
                    <span v-if="data.item.tipo_precio == 1"> $ </span> 
                    <span v-else> % </span> 
                    {{numberFormat(data.item.precio) }}
                    <b-badge v-if="data.item.tipo_precio == 1 && data.item.precio < data.item.precio" variant="danger">
                        <b-icon v-b-tooltip.hover title="Este precio es menor que el del proveedor." 
                        icon="exclamation-circle-fill" ></b-icon>
                    </b-badge>
                </template>
                <template v-slot:cell(created_at)="data">
                    {{ data.item.created_at }}
                </template>
                <template v-slot:cell(actions)="{ item }">
                    <b-row>
                    <b-button variant="info" v-b-tooltip.hover title="Actualizar Precio" class="text-white mr-2" 
                        @click="$emit('open-update-modal', item)">
                        <b-icon icon="arrow-clockwise" ></b-icon>
                    </b-button>
                    <b-button variant="danger" v-b-tooltip.hover title="Eliminar Registro" class="text-white" 
                        @click="$emit('open-delete-modal', item)">
                        <b-icon icon="trash" ></b-icon>
                    </b-button>
                    </b-row>
                </template>
            </b-table>
            <template v-if="items.length < 1">
                <b-alert show variant="danger">
                    Lo sentimos, no se han encontrado resultados para su busqueda.
                </b-alert>
            </template>
        </b-card-text>
        <template v-slot:footer>
            <div class="mt-3">
                <b-row>                            
                    <b-col cols="12" md="4">
                        <b-pagination 
                            size="md" 
                            pills 
                            :total-rows="paginator.totalPage" 
                            v-model="paginator.page" 
                            :per-page="1" 
                            @input="changePage" 
                            first-number 
                            last-number>
                        </b-pagination>
                    </b-col>
                    <b-col cols="12" sm="2">
                        <b-form-select @change="updatePageSize()" v-model="paginator.pageSize" :options="pageSize" ></b-form-select>
                    </b-col>
                </b-row>
            </div>
        </template>
    </b-card>
</template>

<script>
import { mapState } from 'vuex'
export default {
    name: "ItemsTable",
    props: {
        items: {
            type: Array
        },
        paginator: {
            type: Object
        },
        pageSize: {
            type: Array
        }
    },
    computed: {
        ...mapState('configuration', ['urlWebBackend']),
        ...mapState('auth', ['user']),
    },
    data(){
        return{
            fields: [
                { key: 'codigo', label: 'Codigo Item', sortable: true},
                { key: 'imagen', label: 'Descripción', sortable: true},
                { key: 'precio', label: 'Precio Personalizado', sortable: true},
                { key: 'created_at', label: 'Fecha', sortable: true},
                { key: 'actions', label: 'Acciones'},
            ],
        }
    },
    methods: {
        updatePageSize(){
            /* the page sizee return the current page to initial because we can't know if the current page have items asigned!! */
            this.paginator.page = 1;
            /* emit the page size update to get the new list of items*/
            this.$emit('get-items');
        },
        changePage(){
            this.$emit('change-page', this.paginator.page);            
        }
    }
};

</script>
<style scoped>

</style>